import React from 'react'
import Icons from '@atoms/Icons/Icons'

const ScrollToTopButton = () => {
  const handleScroll = () =>
    window && window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  return (
    <div
      className='hidden h-fit w-fit cursor-pointer border border-solid border-white md:block'
      onClick={() => handleScroll()}
    >
      <Icons iconName='ArrowUp' color='#FFF' height='36px' width='36px' />
    </div>
  )
}

export default ScrollToTopButton
